import api from './axios';

// Get dashboard stats
export const getDashboardStats = async () => {
  const response = await api.get('/dashboard/stats');
  return response.data;
};

// Team Lead: Get team members
export const getTeamMembers = async () => {
  const response = await api.get('/team-lead/team-members');
  return response.data;
};

// Team Lead: Get team performance
export const getTeamPerformance = async () => {
  const response = await api.get('/team-lead/team-performance');
  return response.data;
};

// Manager: Get all agents
export const getAllAgents = async () => {
  const response = await api.get('/manager/agents');
  return response.data;
};

// Manager: Create agent
export const createAgent = async (data) => {
  const response = await api.post('/manager/agent/create', data);
  return response.data;
};

// Manager: Update agent
export const updateAgent = async (agentId, data) => {
  const response = await api.put(`/manager/agent/${agentId}/update`, data);
  return response.data;
};

// Manager: Delete agent
export const deleteAgent = async (agentId) => {
  const response = await api.delete(`/manager/agent/${agentId}/delete`);
  return response.data;
};

// Manager: Get analytics
export const getSystemAnalytics = async () => {
  const response = await api.get('/manager/analytics');
  return response.data;
};

// Get activity log
export const getActivityLog = async () => {
  const response = await api.get('/activity-log');
  return response.data;
};
